module.exports = __webpack_public_path__ + "static/media/signal-3.0529d854.svg";